@if (label() === true) {
  <div class="label-placeholder"></div>
} @else if (label()) {
  <onyx-input-label
    [label]="$any(label())"
    [hint]="hint()"
    [required]="required()"
    [disabled]="disabled()"
    (click)="focus()"
  ></onyx-input-label>
}

@let isDisabled = disabled() || (value().indefinite && showIndefinite());
@let hasClear = value().day && !isDisabled && showClear();
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div
  class="datepicker-input size-{{ size() }}"
  [class.active]="value().year"
  [class.disabled]="isDisabled"
  [class.invalid]="isInvalid() || forceError()"
  [class.warning]="hasWarning()"
  [class.clear]="hasClear"
  [class.hide-year]="!showYear()"
  (click)="isDisabled ? null : inputClick.emit($event)"
  (focusout)="inputFocusout.emit($event)"
  #inputElement
>
  <div class="input-date">
    <input
      data-testid="day-input"
      class="day"
      type="text"
      placeholder="DD"
      [disabled]="isDisabled"
      (keypress)="validateInput($event)"
      (input)="changeDay($event)"
      (paste)="pasteDate($event)"
    />

    <span class="input-date-separator">/</span>

    <input
      data-testid="month-input"
      class="month"
      [class.value]="value().month"
      placeholder="MM"
      [disabled]="isDisabled"
      [tabIndex]="value().day ? 0 : -1"
      (keypress)="validateInput($event)"
      (input)="changeMonth($event)"
      (paste)="pasteDate($event)"
      (focus)="focus(value().day, 0)"
      (keydown.backspace)="previousInput($event)"
    />

    <span class="input-date-separator year-separator">/</span>

    <input
      data-testid="year-input"
      class="year"
      placeholder="RRRR"
      [maxLength]="4"
      [disabled]="isDisabled"
      [tabIndex]="value().month ? 0 : -1"
      (keypress)="validateInput($event)"
      (input)="changeYear($event)"
      (paste)="pasteDate($event)"
      (focus)="focus(value().month, 2)"
      (keydown.backspace)="previousInput($event)"
    />
  </div>

  <div class="actions">
    <div class="hidden">
      @if (hasClear) {
        <onyx-clear-button
          data-testid="clear-button"
          (click)="clearValue(); $event.stopPropagation()"
        ></onyx-clear-button>
      }
    </div>
  </div>

  <onyx-icon-button variant="transparent" color="gray" [size]="20">
    <onyx-icon
      class="calendar-icon"
      name="calendar-outlined"
      [size]="20"
    ></onyx-icon>
  </onyx-icon-button>
</div>

@if (showIndefinite()) {
  <onyx-checkbox
    [label]="
      (indefiniteLabel() ? indefiniteLabel()! : `${I18N}.indefinite`)
        | translate
    "
    [checked]="!!value().indefinite"
    (checkedChange)="changeIndefinite($event)"
    [showRequired]="false"
    [showErrors]="false"
  ></onyx-checkbox>
}
